import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getStatisticsSummaryRequest,
  GetStatisticsSummaryParams,
} from "../../api/statisticsApi";
import { StatisticsSummaryResponse } from "../../models/ResponseModels/StatisticsSummaryResponse";
import {
  getApiErrorMessage,
  getApiErrorPayload,
} from "../../utils/helperFunctions/apiErrorHelper";

interface StatisticsState {
  summary: StatisticsSummaryResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: StatisticsState = {
  summary: null,
  loading: false,
  error: null,
};

export const fetchStatisticsSummary = createAsyncThunk(
  "statistics/fetchStatisticsSummary",
  async (
    params: GetStatisticsSummaryParams | undefined,
    { rejectWithValue },
  ) => {
    try {
      return await getStatisticsSummaryRequest(params);
    } catch (error: any) {
      return rejectWithValue(getApiErrorPayload(error));
    }
  },
);

const statisticsSlice = createSlice({
  name: "statistics",
  initialState,
  reducers: {
    clearStatisticsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStatisticsSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStatisticsSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.summary = action.payload;
      })
      .addCase(fetchStatisticsSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = getApiErrorMessage(
          action.payload,
          "Failed to load statistics.",
        );
      });
  },
});

export const { clearStatisticsError } = statisticsSlice.actions;

export default statisticsSlice.reducer;
